import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { PubSubNotificationTypes } from "src/enums/Notifications";
import { useNotifications } from "src/hooks/useNotifications";
import { setStudentDataUpdating } from "src/redux/redux-store/knowledge-base/knowledgebaseReducer";

export const useBackgroundNotifications = () => {
    const client = useNotifications()?.client;
    const dispatch = useDispatch();

    useEffect(() => {
        if (client) {
            // Join admin group when client is available
            client.joinGroup("admin")
                .then(() => console.log("useBackgroundNotifications: Joined 'admin' group"))
                .catch((e) => console.error("useBackgroundNotifications: Error joining 'admin' group:", e));

            const handleMessage = (data: any) => {
                if (data.message.data) {
                    try {
                        const message = JSON.parse(data.message.data.toString());
                        console.log("Background Notification:", message);

                        if (message.event_type === PubSubNotificationTypes.studentDataUpdate) {
                            // Update Redux state with actual data from the event
                            dispatch(setStudentDataUpdating({
                                isUpdating: true,
                                info: message.info,
                                processedCount: message.processed_count,
                                fileId: message.file_id
                            }));

                            // If process is complete, close drawer after delay
                            const infoLower = message.info?.toLowerCase() || "";
                            if (infoLower.includes("successfully") || infoLower.includes("completed")) {
                                setTimeout(() => {
                                    dispatch(setStudentDataUpdating({
                                        isUpdating: false,
                                        info: null,
                                        processedCount: 0,
                                        fileId: null
                                    }));
                                }, 3000);
                            }
                        }
                    } catch (e) {
                        console.error("Error parsing background message", e);
                    }
                }
            };

            client.on("group-message", handleMessage);
            return () => {
                client.off("group-message", handleMessage);
            };
        }
    }, [client, dispatch]);

    // Export function to trigger placeholder drawer
    const showPlaceholderDrawer = () => {
        dispatch(setStudentDataUpdating({
            isUpdating: true,
            info: "Updated Count: 0",
            processedCount: 0,
            fileId: null
        }));
    };

    return { showPlaceholderDrawer };
};
